// Path constants
export const HOME_PATH = "/";

export const LOGIN_PATH = "/auth/login"
export const LOGIN_PATH_WITH_EMAIL = "/auth/login/:email"
export const SIGNUP_PATH = "/auth/signup"
// Trial-invite variant: same signup, but a VALID invite token in the URL (path segment, e.g.
// /auth/signup/RIQFRE-XXXXXX, or ?coupon_code=RIQFRE-XXXXXX) makes the plan page ALSO show
// "Start 7-day free trial". Plain /auth/signup (or a bogus token) is buy-now only. Tokens are
// validated in SignupScreen against baked djb2 hashes — plaintext never ships in the bundle.
export const SIGNUP_TRIAL_PATH = "/auth/signup/:invite"
// Universal-login handoff: app.reachiq.ai redirects an account-in-progress user here
// (?draft_id&step&email...) to resume signup at their exact pending step.
export const SIGNUP_RESUME_PATH = "/auth/resume"
// Draft password reset (Continue-Setup email lands here first, then drops on the step)
export const RESET_DRAFT_PASSWORD_PATH = "/auth/reset-draft-password"
export const FORGOT_PASSWORD_PATH = "/auth/forgot_password"
export const EMAIL_VERIFICATION_PATH = "/auth/email_verify/:id"
export const FORGOT_PASSWORD_MAIL_SEND_PATH = "/auth/reset_password/verify/:id"

// Google Routes
export const GOOGLE_REDIRECT_PATH = "/auth/google-verify"
export const GOOGLE_LOGIN_PATH = "/auth/google-login"
export const GOOGLE_SIGNUP_PATH = "/auth/google-signup"
export const CONNECT_INBOX_PATH = "/auth/connect-inbox/:type/:host"
export const CONNECT_INBOX_GOOGLE_REDIRECT_PATH = "auth/google-connect-inbox"
export const CONNECT_INBOX_MICROSOFT_REDIRECT_PATH = "auth/microsoft-connect-inbox"
export const CONNECT_INBOX_ZOHO_REDIRECT_PATH = "auth/zoho-connect-inbox"

//Microsoft Routes
export const MICROSOFT_REDIRECT_PATH = "/auth/microsoft-web-verify"
export const MICROSOFT_LOGIN_PATH = "/auth/microsoft-login"
export const MICROSOFT_SIGNUP_PATH = "/auth/microsoft-signup"

export const WAITING_PAGE_PATH = "/account-inactive"
export const INVALID_PAGE_PATH = "/invalid-page"
export const INVALID_TOKEN_PATH = "/auth/invalid_token"
export const PEOPLE_SCREEN_PATH = "/user/leads";
export const PROFILE_PATH = "/user/profile"
export const INITIAL_ROUTE = "/onboarding-form"

// ─── New Onboarding Flow Routes (v2 revamp) ───
export const PLAN_PATH = "/auth/plan"
export const CREATE_WORKSPACE_PATH = "/auth/create-workspace"
export const VERIFY_EMAIL_PENDING_PATH = "/auth/verify-email-pending"
// NOTE: the old "/auth/workspace-setup" route was removed — EmailVerification now
// shows the workspace-preparation loader inline and redirects straight to the tenant
// login, so the intermediate screen/route is no longer part of the flow.
export const WELCOME_PATH = "/auth/welcome"

// ─── Stripe payment return routes ────────────────────────────────────────────
export const PAYMENT_SUCCESS_PATH = "/signup/payment/success"
export const PAYMENT_CANCEL_PATH  = "/signup/payment/cancel"
// ─────────────────────────────────────────────────────────────────────────────
